// @flow strict
import React from 'react';
import moment from 'moment/min/moment-with-locales';
import './Meta.scss';

type Props = {
  date: string;
};

const Meta = ({ date }: Props) => (
  <div className="meta">
    <p className="meta__date">Publicado el {getPublishedDate(date)}</p>
  </div>
);

export default Meta;
function getPublishedDate(date) {
  return moment(date).locale('es').format('LL');
}
